var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoldicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 24,
    height: 24,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-65.25 -515.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "keypadicon",
    transform: "translate(119.25 512.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 27.25,
    cy: 27.25,
    r: 27.25,
    transform: "translate(-53.25 3.75)",
    fill: "#fff",
    stroke: "#f3f7fb",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "hold",
    transform: "translate(81 531)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M16,18a1.5,1.5,0,0,1-1.5-1.5v-9a1.5,1.5,0,1,1,3,0v9A1.5,1.5,0,0,1,16,18Z",
    fill: "none",
    stroke: "#080428",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M8,18a1.5,1.5,0,0,1-1.5-1.5v-9a1.5,1.5,0,1,1,3,0v9A1.5,1.5,0,0,1,8,18Z",
    fill: "none",
    stroke: "#080428",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldicon);
export default __webpack_public_path__ + "static/media/holdicon.914860e4758175b4795f46d4fdbecd5e.svg";
export { ForwardRef as ReactComponent };